<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="true"
        class="bg-black fixed h-screen bg-opacity-70 inset-0 z-50 w-full"
      >
        <form
          @submit.prevent="editJobInfo"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full overflow-y-auto"
          style="height: auto"
        >
          <!-- {{ data }} -->
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-50 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Edit Job Information</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>

          <transition name="fade">
            <div
              v-if="get_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ edit_error }}
            </div>
          </transition>

          <transition name="fade">
            <div
              v-if="showUpdateSuccess"
              class="p-1 text-center text-sm w-full bg-green-200"
            >
              {{ showUpdateSuccess }}
            </div>
          </transition>
          <!-- {{ empData }} -->
          <div class="p-4 grid grid-cols-2 gap-4">
            <div
              class="text-sm col-span-1"
              v-for="info of empData"
              :key="info.name"
            >
              <div v-if="info.type === 'date'">
                <div class="text-sm col-span-1">
                  <div class="">
                    <label class="block pb-1">{{ info.name }} </label>
                    <input
                      type="date"
                      v-model="data[info.label]"
                      required
                      class="p-2 bg-gray-200 rounded-md w-full"
                    />
                  </div>
                </div>
              </div>

              <div class="" v-else-if="info.type !== 'select'">
                <label class="block pb-1">{{ info.name }}</label>
                <input
                  v-model="data[info.label]"
                  :name="info.name"
                  :type="info.type"
                  class="p-2 bg-gray-200 rounded-full w-full"
                />
              </div>

              <div class="relative" v-else>
                <!-- {{ info }} -->
                <label class="block pb-1">{{ info.name }}</label>

                <div v-if="info.index === 0">
                  <select
                    name=""
                    id=""
                    class="py-2 px-4 hover:bg-gray-200 cursor-pointer shadow w-full rounded-full"
                    v-model="data[info.label]"
                  >
                    <option
                      selected
                      disabled
                      v-if="saved_employment_types.length == 0"
                    >
                      Select Employment Type
                    </option>

                    <option
                      v-for="option in saved_employment_types"
                      :key="option.Id"
                      :value="option.Name"
                    >
                      {{ option.Name }}
                    </option>
                  </select>
                </div>

                <div
                  v-if="
                    info.index === 1 &&
                    getTabTitle.trim() !== 'Employee Departments'
                  "
                >
                  <select
                    name=""
                    id=""
                    class="py-2 px-4 hover:bg-gray-200 cursor-pointer shadow w-full rounded-full"
                    @change="(e) => updateField(e, info.label)"
                  >
                    <option selected disabled v-if="info.options.length == 0">
                      Select
                    </option>
                    <option
                      v-for="option in info.options"
                      :key="option"
                      :selected="statusSelected === info.label"
                    >
                      {{ option }}
                    </option>
                  </select>
                </div>
                <div
                  v-if="
                    info.index === 1 &&
                    getTabTitle.trim() === 'Employee Departments'
                  "
                  class="py-5"
                >
                  <!-- <label for="" class="font-bold mb-2">Departments</label> -->
                  <div class="grid grid-cols-2 gap-4 text-sm">
                    <select
                      name=""
                      id=""
                      class="py-2 px-4 hover:bg-gray-200 cursor-pointer shadow w-full rounded-full"
                      @change="(e) => setDepartment(e)"
                    >
                      <option selected disabled v-if="info.options.length == 0">
                        Select Job Title
                      </option>
                      <option default disabled selected>Job Title</option>
                      <option
                        v-for="option in info.options"
                        :key="option"
                        :selected="statusSelected === info.label"
                      >
                        {{ option }}
                      </option>
                    </select>

                    <select
                      name=""
                      id=""
                      class="py-2 px-4 hover:bg-gray-200 cursor-pointer shadow w-full rounded-full"
                      @change="(e) => assignEmployeeDepartments(e)"
                    >
                      <option default disabled selected>
                        Select Department
                      </option>
                      <option
                        v-for="title in saved_jobTitles"
                        :key="title.Name"
                        :disabled="!selectedDepartment"
                      >
                        {{ title.Name }}
                      </option>
                    </select>
                  </div>
                </div>

                <div v-if="info.index === 2">
                  <select
                    name=""
                    id=""
                    class="py-2 px-4 hover:bg-gray-200 cursor-pointer shadow w-full rounded-full"
                    @change="(e) => updateField(e, info.label)"
                  >
                    <option selected disabled v-if="info.options.length == 0">
                      Select
                    </option>
                    <option
                      v-for="option in info.options"
                      :key="option"
                      :selected="statusSelected === info.label"
                    >
                      {{ option }}
                    </option>
                  </select>
                </div>
                <div v-if="info.index === 3">
                  <select
                    name=""
                    id=""
                    class="py-2 px-4 hover:bg-gray-200 cursor-pointer shadow w-full rounded-full"
                    @change="(e) => updateField(e, info.label)"
                  >
                    <option selected disabled v-if="info.options.length == 0">
                      Select
                    </option>
                    <option
                      v-for="option in info.options"
                      :key="option"
                      :selected="statusSelected === info.label"
                    >
                      {{ option }}
                    </option>
                  </select>
                </div>
                <div v-if="info.index === 4">
                  <!-- {{ saved_employment_status}} -->
                  <select
                    name=""
                    id=""
                    class="py-2 px-4 hover:bg-gray-200 cursor-pointer shadow w-full rounded-full"
                    v-model="data[info.label]"
                  >
                    <option
                      selected
                      disabled
                      v-if="saved_employment_status.length == 0"
                    >
                      Select Employment Status
                    </option>
                    <option
                      v-for="option in saved_employment_status"
                      :key="option.employmentStatusId"
                      :selected="statusSelected === info.label"
                      :value="option.Name"
                    >
                      {{ option.Name }}
                    </option>
                  </select>
                </div>

                <div v-if="info.index === 5">
                  <select
                    v-model="data[info.label]"
                    name=""
                    id=""
                    class="py-2 px-4 hover:bg-gray-200 cursor-pointer shadow w-full rounded-full"
                  >
                    <option disabled v-if="info.options.length == 0">
                      Select Job Grade
                    </option>
                    <option
                      v-for="option in saved_jobgrades"
                      :key="option.Id"
                      :value="option.Name"
                    >
                      {{ option.Name }}
                    </option>
                  </select>
                </div>
                <div v-if="info.index === 6">
                  <select
                      v-model="data[info.label]"
                      name=""
                      id=""
                      class="py-2 px-4 hover:bg-gray-200 cursor-pointer shadow w-full rounded-full"
                  >
                    <option disabled v-if="info.options.length == 0">
                     Select Job Title
                    </option>
                    <option
                        v-for="option in saved_jobTitles"
                        :key="option.Id"
                        :value="option.Name"
                    >
                      {{ option.Name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import Loader from "@/components/loader/loader.vue";
import { mapGetters } from "vuex";
import decryptData from "@/utils/decrypt";
export default {
  name: "EditEmployee",
  props: [
    "editJobInformation",
    "terminationInfo",
    "generalWorkInfo",
    "employeeDepartmentsInfo",
    "sectionData",
    "empData",
    "reload",
    "close",
  ],
  components: { Loader },
  data() {
    return {
      loading: false,
      show: [false, false],
      display: false,
      genderSelected: "",
      showGender: false,
      showUpdateSuccess: null,
      statusSelected: "",
      showStatus: false,
      create_error: null,
      edit_error: null,
      saved_jobTitles: [],
      selectedDepartment: null,
      saved_departments: [],
      saved_locations: [],
      saved_roles: [],
      saved_employment_types: [],
      saved_salutation: ["Mrs", "Ms", "Mr", "Sir"],
      saved_genders: ["Male", "Female"],
      saved_maritualstatus: ["Married", "Single", "Divorced", "Widowed"],
      data: this.sectionData?.formdata,
      info: {
        EmployeeId: "",
        EmployeeNo: "",
        DateofJoining: "",
        EmployementTypeId: "",
        PayrollNumber: "",
        JobGradeId: "",
        EmployementStatusId: "",
        JobTitleId:""
      },
      jobTitles:[]
    };
  },

  computed: {
    ...mapGetters([
      "getOrganization",
      "getToken",
      "getTabTitle",
      "getCurrentEmployeeId",
      "getUser",
    ]),
  },
  created() {
    console.log(this.data)
    this.getSavedData();

    this.empData.map((info) => {
      this.data[info.label ? info.label : info.name.split(" ").join("")] =
        decryptData(info.value, this.$decryptionKey);
    });
    // alert(JSON.stringify(info.value));

    if (this.getTabTitle.trim() === "General Work Information") {
      //console.log(this.empData)
      this.generalWorkInfo.map((info) => {
        this.data[info.label] = decryptData(info.value, this.$decryptionKey);
      });

      // console.log(this.generalWorkInfo);

      this.employeeDepartmentsInfo.map((info) => {
        this.data[info.label] = decryptData(info.value, this.$decryptionKey);
      });
    } else if (this.getTabTitle.trim() === "Employee Departments") {
      this.employeeDepartmentsInfo.map((info) => {
        this.data[info.label] = decryptData(info.value, this.$decryptionKey);
      });
      this.terminationInfo?.map((info) => {
        this.data[info.label] = decryptData(info.value, this.$decryptionKey);
      });
    } else if (this.getTabTitle.trim() === "Termination Information") {
      this.generalWorkInfo.map((info) => {
        this.data[info.label] = decryptData(info.value, this.$decryptionKey);
      });
      this.terminationInfo.map((info) => {
        this.data[info.label] = decryptData(info.value, this.$decryptionKey);
      });
    }
  },
  methods: {
    getJobTitles(){

    },
    setDepartment(e) {
      const { value } = e.target;
      // console.log(value);
      this.selectedDepartment = this.saved_departments.find(
        (department) => department.Name === value
      );
      //console.log(this.selectedDepartment);
    },

    isAssigned(dep) {
      //console.log(this.employeeDepartmentsInfo[0].value)
      if (this.employeeDepartmentsInfo[0].value.length > 0) {
        return this.employeeDepartmentsInfo.filter(
          (department) => department.trim() === dep.trim()
        ).length >= 1
          ? true
          : false;
      }
      return false;
    },
    // /{organization}/employee/department/v1/edit
    assignEmployeeDepartments(e) {
      const { value } = e.target;
      //console.log(value)
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      const jobTitleSelected = this.saved_jobTitles.find(
        (jobTitle) => jobTitle.Name === value.trim()
      );
      //console.log(this.selectedDepartment, this.getUser)
      const data = {
        EmployeeDepartmentId: this.DepartmentId,
        LocationId: this.selectedDepartment.LocationId,
        BranchId: this.selectedDepartment.BranchId,
        DepartmentId: this.selectedDepartment.DepartmentId,
        JobTitleId: jobTitleSelected.Id,
      };
      //console.log(data)
      axios
        .put(
          `${this.getOrganization}/employee/department/${this.$ApiVersion}/edit`,
          data,
          options
        )
        .then(
          (response) => {
            if (response.data.StatusCode == 200) {
              this.loading = false;
              setTimeout(() => {
                this.create_success = null;
              }, 2500);
            } else {
              this.create_error = response.data.StatusMessage;
              this.loading = false;
              setTimeout(() => {
                this.create_error = null;
              }, 2500);
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },

    editJobInfo() {
      switch (this.getTabTitle.trim()) {
        case "General Work Information":
          this.editGeneralJobInfo();
          break;
        case "Employee Departments":
          this.editEmployeeDepartmentInfo();

          break;
        case "Termination Information":
          break;

        default:
          break;
      }
    },
    updateField(e, field) {
      if (field === "DateOfJoining") {
        this.data = { ...this.data, [field]: e };
        return;
      }
      const { value } = e.target;
      this.data = { ...this.data, [field]: value };
    },
    setGender(option) {
      this.genderSelected = option;
      this.showGender = false; // hide the dropdown after an option is selected
    },
    setStatus(option) {
      this.statusSelected = option;
      this.showStatus = false; // hide the dropdown after an option is selected
    },
    toggleShow(index) {
      this.show[index] = !this.show[index];
    },

    // /{organization}/employee/job/v1/edit
    editGeneralJobInfo() {
      const info = {
        EmployeeId: "",
        EmployeeNo: "",
        DateofJoining: "",
        EmployementTypeId: "",
        WorkEmail: "",
        JobGradeId: "",
        PayrollNumber: "",
        EmployementStatusId: "",
        JobTitleId:""
      };
      // console.log(this.info);

      info.EmployeeId = this.getCurrentEmployeeId;
      info.EmployeeNo = this.data.EmployeeNo;
      info.DateofJoining = this.data.DateOfJoining;
      info.WorkEmail = this.data.WorkEmail;
      info.PayrollNumber = this.data.PayrollNumber;
      info.EmployementTypeId = this.saved_employment_types.find(
        (type) => type.Name === this.data.EmploymentType
      )?.Id;
      info.JobGradeId = this.saved_jobgrades.find(
        (grade) => grade.Name === this.data.GradeId
      )?.Id;

      info.JobTitleId = this.saved_jobTitles.find(
          (title) => title.Name === this.data.JobTitle
      )?.Id;
      info.EmployementStatusId = this.saved_employment_status.find(
        (status) => status.Name === this.data.EmploymentStatus
      )?.employmentStatusId;
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      axios
        .put(
          `${this.getOrganization}/employee/work/information/${this.$ApiVersion}/edit`,
          JSON.stringify(info),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.showUpdateSuccess = response.data.StatusMessage;
              this.$notify({
                title: "Success",
                message: response.data.StatusMessage,
                type: "success",
              });
              setTimeout(() => {
                this.showUpdateSuccess = null;
                this.$emit("closeOnSuccess", response.data.StatusMessage);
                this.reload();
              }, 2500);
            } else {
              this.create_error = response.data.StatusMessage;
              this.$notify.error({
                title: "Failure",
                message: response.data.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
            this.$notify.error({
              title: "Failure",
              message: error.message,
            });
          }
        );
    },
    // /{organization}/employee/department/v1/edit
    editEmployeeDepartmentInfo() {
      this.data.EmployeeId = this.getCurrentEmployeeId;
      //console.log(this.data, this.saved_departments, this.saved_locations);
      this.data.DepartmentId = this.saved_departments.find(
        (department) =>
          department.Name.trim().toLowerCase() ===
          this.data.DepartmentId.trim().toLowerCase()
      ).DepartmentId;

      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      //console.log(this.data)
      this.data = {
        ...this.terminationInfo,
        ...this.generalWorkInfo,
        ...this.employeeDepartmentsInfo,
        ...this.data,
      };
      console.log(this.data);
      axios
        .put(
          `${this.getOrganization}/employee/department/${this.$ApiVersion}/edit`,
          JSON.stringify(this.data),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.showUpdateSuccess = response.data.StatusMessage;
              this.$notify({
                title: "Success",
                message: response.data.StatusMessage,
                type: "success",
              });

              this.reload();
              setTimeout(() => {
                this.showUpdateSuccess = null;
                this.$emit("closeOnSuccess", response.data.StatusMessage);
              }, 2500);
            } else {
              this.create_error = response.data.StatusMessage;
              this.$notify.error({
                title: "Failure",
                message: response.data.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
            this.$notify.error({
              title: "Failure",
              message: error.message,
            });
          }
        );
    },

    getSavedData() {
      this.loading = true;
      let endpoints = [
        `${this.getOrganization}/setup/jobtitle/${this.$ApiVersion}/request`,
        `${this.getOrganization}/setup/location/${this.$ApiVersion}/request`,
        `${this.getOrganization}/setup/jobgrade/${this.$ApiVersion}/request`,
        `${this.getOrganization}/setup/employementtype/${this.$ApiVersion}/request`,
        `${this.getOrganization}/setup/department/${this.$ApiVersion}/request`,
        `${this.getOrganization}/setup/employment/status/${this.$ApiVersion}/request`,
      ];
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      Promise.all(endpoints.map((endpoint) => axios.get(endpoint, options)))
        .then(
          axios.spread((...response) => {
            this.loading = false;
            this.saved_jobTitles = response[0].data.Data;
            this.saved_locations = response[1].data.Data;
            this.saved_jobgrades = response[2].data.Data;
            this.saved_employment_types = response[3].data.Data;
            this.saved_departments = response[4].data.Data;
            this.saved_employment_status = response[5].data.Data;

            switch (this.getTabTitle.trim()) {
              case "General Work Information":
                this.empData[1].options = this.saved_employment_types.map(
                  (empType) => empType.Name
                );
                this.empData[2].options = this.saved_jobgrades.map(
                  (grade) => grade.Name
                );
                this.empData[4].options = this.saved_employment_status.map(
                  (status) => status.Name
                );
                break;
              case "Employee Departments":
                this.empData[0].options = this.saved_departments.map(
                  (department) => department.Name
                );
                break;
              case "Termination Information":
                break;

              default:
                break;
            }
          })
        )
        .catch(() => {
          this.loading = false;
        });
    },
    getDepartments(LocationId) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/location/${LocationId}/departments/${this.$ApiVersion}/request`,
          options
        )
        .then((response) => {
          this.loading = false;
          this.saved_departments = response.data.LocationDepartments;
        });
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
